import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { NgIdleService } from '@core/services/user-idle-manager/ng-idle.service';
import { MatDialog } from '@angular/material/dialog';
import { SessionDialogComponent } from '@shared/components/session-dialog/session-dialog.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [
    NgIdleService
  ]
})

export class AppComponent {
  idleState = 'Not started.';
  idleSecondState = 0;

  private firstTimerEventSubscription: Subscription;
  private secondTimerEventSubscription: Subscription;

  constructor(public idle: NgIdleService,
              public authService: AuthService,
              private router: Router,
              public dialog:MatDialog,
              private localStorageService: LocalStorageService
              )
    {
       this.idleState = 'Started.';
       this.idle.initilizeSessionTimeout();
       this.firstWatch();
  }

  firstWatch(): void {
    // Watcher on timer
    this.firstTimerEventSubscription=this.idle.userIdlenessChecker.subscribe((status: string) => {
      if (this.authService.Isauthenticated && status != 'NaN') {
        this.initiateFirstTimer(status);
      }
    });
  }

  secondWatch(): void {
   this.secondTimerEventSubscription=this.idle.secondLevelUserIdleChecker.subscribe((status: string) => {
      if (this.authService.Isauthenticated && status != 'NaN') {       
         this.initiateSecondTimer(status);
      }
    });
  }

  initiateFirstTimer = (status: string) => {
    switch (status) {
      case 'INITIATE_TIMER':
        break;

      case 'RESET_TIMER':
        break;

      case 'STOPPED_TIMER':
        break;

     case 'START_SECOND_TIMER':
        this.secondTimerStart();
        break;

      default:
        if (!this.idle.FirstTimeOut) {
          this.idleState = 'You will be timeout in ' + this.formatTimeLeft(Number(status)) + ' seconds!';
        }
        break;
    }
  }

  initiateSecondTimer = (status: string) => {
    switch (status) {
      case 'INITIATE_SECOND_TIMER':
        break;
      case 'SECOND_TIMER_STARTED':
            this.idleSecondState = 0;
        break;
      case 'SECOND_TIMER_RESET':
           this.secondTimerReset();
      break;
      case 'SECOND_TIMER_STOPPED':
            this.secondTimerStopped();
        break;
      default:
            this.popupDialog();
            this.idleSecondState = Number(status)*1000;
            this.localStorageService.setItem('timeLeft',this.idleSecondState.toString());
        break;
    }
  }



  /*****Draw timer circle*****/
  formatTimeLeft = (time: number) => {
    if (time > 0) {
      let seconds = Math.trunc(time / 1000);
      return `${seconds}`;
    }
  }
 

  popupDialog(): void {
    if (this.dialog.openDialogs.length>0) return;
    const dialogRef = this.dialog.open(SessionDialogComponent, {
      width: '270px',
      data: this.idleSecondState,
      disableClose:true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if(result.data=="reset")
        {
           this.idle.SecondTimeOut = false;
           this.idle.FirstTimeOut=false;
           this.idle.removeSecondActionFromStore();
           if(this.secondTimerEventSubscription)
          {
             this.secondTimerEventSubscription.unsubscribe();
             this.secondTimerEventSubscription=undefined;
          }
          if(this.firstTimerEventSubscription==undefined)
          {
            this.idle.userIdlenessChecker = new BehaviorSubject<string>('INITIATE_TIMER');
            this.firstWatch();
          }
          else
          {
            this.idle.userIdlenessChecker.next('INITIATE_TIMER');
          }
           this.idle.initilizeSessionTimeout();
           this.idle.removeAllActionFromStore();
           this.localStorageService.removeItem('timeLeft');
           this.dialog.closeAll();
        }
        // DO SOMETHING
      }
    });
  }

  secondTimerReset():void{
    this.idle.lastAction=Date.now();
    this.idle.SecondTimeOut = false;
    this.idle.FirstTimeOut=false;
    this.idle.removeSecondActionFromStore();
    if(this.secondTimerEventSubscription)
   {
      this.secondTimerEventSubscription.unsubscribe();
      this.secondTimerEventSubscription=undefined;
   }
   if(this.firstTimerEventSubscription==undefined)
   {
     this.idle.userIdlenessChecker = new BehaviorSubject<string>('INITIATE_TIMER');
     this.firstWatch();
   }
   else
   {
      this.idle.userIdlenessChecker.next('INITIATE_TIMER');
   }
    this.idle.initilizeSessionTimeout();
    this.localStorageService.removeItem('timeLeft');
    this.dialog.closeAll();
  }

  secondTimerStopped():void{
    this.idle.SecondTimeOut = true;
    this.idle.removeSecondActionFromStore();
    if(this.secondTimerEventSubscription)
    {
       this.secondTimerEventSubscription.unsubscribe();
       this.secondTimerEventSubscription=undefined;
    }
    this.authService.revokeToken();
    this.router.navigate(['/gotologin']);
    this.dialog.closeAll();
    this.localStorageService.removeItem('timeLeft');
  }

  secondTimerStart():void{
    this.idle.FirstTimeOut=true;
    this.idle.SecondTimeOut = false;
    if(this.secondTimerEventSubscription==undefined)
    {
      this.idle.secondLevelUserIdleChecker = new BehaviorSubject<string>('INITIATE_SECOND_TIMER');
      this.secondWatch();
    }
    this.idle.initilizeSecondSessionTimeout();
  }
}
